import { call, takeLatest, select, put } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import transformationConfig from '../constants/transformationConfig';
import {
  setTransformationConfig,
  loadTranformationConfig as loadTranformationConfigAction,
  showUILoader,
  hideUILoader,
  setReactFlowError,
} from '../store';

function* loadTranformationConfig() {
  try {
    // @ts-ignore
    // const token = yield select(selectToken);
    // @ts-ignore
    // const headers = yield call(getRequestHeaders, token);

    yield put(showUILoader());

    // const { data } = yield call(makeRequest, { headers, url: `${API.xmlData.root}`, method: 'GET' });;

    yield put(hideUILoader());
    yield put(setTransformationConfig(transformationConfig));
    yield put(setReactFlowError(false));
  } catch (err) {
    console.warn(err);
    yield put(hideUILoader());
    yield put(setReactFlowError(true));
  }
}

export const reactFlowWatchers = [takeLatest(loadTranformationConfigAction.type, loadTranformationConfig)];
